import VueLib from 'vue'
import * as Sentry from '@sentry/browser'
import { Dedupe, ExtraErrorData, ReportingObserver, RewriteFrames, Vue } from '@sentry/integrations'

export default function (ctx, inject) {
  const opts = Object.assign({}, {"dsn":"https:\u002F\u002F72118ec2086a440494e284ef52d90bb7@o28395.ingest.sentry.io\u002F5305588","environment":"prod","release":"master@b020bf6aa9bce48f934ad8795abddf62bf6e067d","beforeSend":(event) => {
  const ieRegex = /MSIE|Trident/i;
  const windowsMobileRegex = /Windows Phone|iemobile|Windows Mobile/i;
  const userAgentFromRequestHeaders = (event && event.request && event.request.headers) ?
    event.request.headers['user-agent'] :
    '';

  const userAgent = typeof window !== 'undefined' ?
    window.navigator.userAgent :
    userAgentFromRequestHeaders;

  const isIE = ieRegex.test(userAgent);
  const isWindowsMobile = windowsMobileRegex.test(userAgent);
  if (isIE || isWindowsMobile) {
    return null;
  }
  return event;
},"ignoreErrors":["l.LegacyGlobal.should_do_lastpass_here","top.GLOBALS","AbortError: Aborted","originalCreateNotification","canvas.contentDocument","MyApp_RemoveAllHighlights","http:\u002F\u002Ftt.epicplay.com","Can't find variable: ZiteReader","jigsaw is not defined","ComboSearch is not defined","http:\u002F\u002Floading.retry.widdit.com\u002F","atomicFindClose","fb_xd_fragment","bmi_SafeAddOnload","EBCallBackMessageReceived","conduitPage","Script error.",new RegExp("^waited \\d+ms but elements? .* still not (present|visible)$", "")]}, {
    integrations: [
      new Dedupe({}),
      new ExtraErrorData({}),
      new ReportingObserver({}),
      new RewriteFrames({}),
      new Vue({Vue: VueLib, ...{"attachProps":true}})
    ]
  })

  // Initialize sentry
  Sentry.init(opts)

  // Inject Sentry to the context as $sentry
  inject('sentry', Sentry)
}
